import {Middleware} from 'redux';
import serializeDates from './serializeDates';

/**
 * Redux middleware to serialize Luxon DateTime in actions
 * @param _store The Redux store instance
 * @param next The next middleware function in the chain
 * @param action The action to be processed
 * @returns The processed action
 */
const luxonDateTimeMiddleware: Middleware = (_store) => (next) => (action) => {
  if (!action) return next(action);

  let transformedAction = action;

  // Only process objects, that might containe DateTime objects. Actions might also be functions (thunks) or primitives that don't need to be serialized.
  if (typeof action === 'object' && action !== null) {
    const serializedAction = serializeDates(action);

    // Only modify the action if DateTime objects were found and serialized
    // This preserves reference equality for avoiding unnecessary re-renders
    if (serializedAction !== action) {
      transformedAction = serializedAction;
    }
  }

  return next(transformedAction);
};

export default luxonDateTimeMiddleware;
